import '../styles/signup.css';

export type SignupStep = 'plan' | 'negocio' | 'pago';

const STEP_LABELS: Record<SignupStep, string> = { plan: 'Plan', negocio: 'Tu negocio', pago: 'Pago' };

/** "Plan · Tu negocio · Pago": where the person is, typographically. Independientes has no Pago. */
export function SignupSteps({ current, withPayment }: { current: SignupStep; withPayment: boolean }) {
  const steps: SignupStep[] = withPayment ? ['plan', 'negocio', 'pago'] : ['plan', 'negocio'];
  return (
    <ol className="signup-steps" aria-label="Pasos del registro">
      {steps.map((step, index) => (
        <li key={step} aria-current={step === current ? 'step' : undefined}>
          <span className="signup-step-number">{index + 1}</span>
          {STEP_LABELS[step]}
        </li>
      ))}
    </ol>
  );
}
